import { c as _c } from "react/compiler-runtime";
import { SphereTooltipIcon } from "@components/common/sphere-tooltip-icon";
import { alpha } from "@mui-wrapper";
import { InfoIcon, grey, HEX_ALPHA } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Size for the help icon that activates the tooltip */
const INFO_ICON_SIZE = "16px";
/** Renders an info icon that shows a tooltip text when hovered */
export function PageSectionInfoIcon(t0) {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      tooltipSx: {
        backgroundColor: "background.paper",
        border: `1px solid ${PALETTE_VARS.divider}`,
        borderRadius: "4px",
        boxShadow: `0px 3px 3px 0px ${alpha(grey[500], HEX_ALPHA.alpha33)}`,
        padding: "16px"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <SphereTooltipIcon text={text} icon={InfoIcon} size={INFO_ICON_SIZE} tooltipProps={t1} />;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}